import DeleteTokenButton from './DeleteTokenButton';

export default DeleteTokenButton;